/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Failed_DescriptionInputs */

const en_auth_failed_description = /** @type {(inputs: Auth_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't verify your session. Try signing in again.`)
};

const pt_br2_auth_failed_description = /** @type {(inputs: Auth_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível verificar sua sessão. Tente entrar novamente.`)
};

/**
* | output |
* | --- |
* | "We couldn't verify your session. Try signing in again." |
*
* @param {Auth_Failed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_failed_description = /** @type {((inputs?: Auth_Failed_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Failed_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_failed_description(inputs)
	return pt_br2_auth_failed_description(inputs)
});